const OSS = require('ali-oss')
const uuidv1 = require('uuid/v1')

// 上传文件
export default async function ossUpload(param: {
    file: { name: string; size: number }
}) {
    let file = param.file
    let fileName = file.name
    let storeAs = `scrm/${uuidv1()}`
    if (fileName.lastIndexOf('.') > -1) {
        storeAs += fileName.slice(fileName.lastIndexOf('.'))
    }
    return new Promise(async (resolve, reject) => {
        multipartUploadWithSts(storeAs, file, null, resolve)
    })
}
// Uint8Array转String
function Uint8ArrayToString(fileData: string | any[]) {
    let dataString = ''
    for (let i = 0; i < fileData.length; i++) {
        dataString += String.fromCharCode(fileData[i])
    }
    return dataString
}

/* eslint-disable */
// 获取token
function multipartUploadWithSts(
    storeAs: string,
    file: { name: string; size: number },
    cpt: null,
    resolve?: any
): void {
    let client: any = null
    let result: any = null
    let errmsg: string = ''
    OSS.urllib.request(
        `${window.location.origin}/common/getSTS.np`,
        { method: 'GET' },
        async function (err: any, response: string | any[]) {
            if (err) {
                return alert(err)
            }
            try {
                result = JSON.parse(Uint8ArrayToString(response)).data
            } catch (e) {
                errmsg = 'parse sts response info error: ' + e.message
                return alert(errmsg)
            }
            if (result) {
                client = new OSS({
                    accessKeyId: result.accessKeyId,
                    accessKeySecret: result.accessKeySecret,
                    stsToken: result.securityToken,
                    bucket: result.bucket || 'yunxi-oss-wx',
                    endpoint:
                        result.endpoint ||
                        'https://oss-cn-beijing.aliyuncs.com',
                })
                multitest(client, storeAs, file, cpt, resolve, result.cdnDomain)
            }
        }
    )
}

/**
 * 处理返回结果
 */
function resolveRes(
    response: { res: any; name: string; etag: any },
    file: { name: string; size: number },
    cdnUrl: string
) {
    let data = response.res
    if (
        response &&
        data &&
        data.requestUrls &&
        data.requestUrls[0] &&
        data.requestUrls[0].indexOf('?uploadId=') !== -1
    ) {
        data.requestUrls[0] = data.requestUrls[0].split('?uploadId=')[0]
    }
    let url = data.requestUrls[0]
    if (cdnUrl) {
        url = 'https://' + cdnUrl + '/' + response.name
    }
    let result = {
        fileName: file.name,
        code: 0,
        url,
        etag: response.etag,
        size: file.size,
    }
    return result
}

// 直传ali
async function multitest(
    ossClient: {
        multipartUpload: (
            arg0: any,
            arg1: any,
            arg2: {
                parallel: number
                checkpoint?: any
                progress:
                    | ((percent: any, cpt: any) => void)
                    | ((percent: any, cpt: any) => void)
            }
        ) => Promise<any>
    },
    storeAs: string,
    file: { name: string; size: number },
    cpt: null,
    resolve: (arg0: {
        data: { fileName: any; code: number; url: any; etag: any; size: any }
        code: number
    }) => void,
    cdnUrl: string
) {
    let checkpoint_temp: any = null
    if (cpt) {
        ossClient
            .multipartUpload(storeAs, file, {
                parallel: 2,
                checkpoint: cpt,
                progress: (percent, cpt) => {
                    checkpoint_temp = cpt
                },
            })
            .then(function (res) {
                let result = resolveRes(res, file, cdnUrl)
                resolve({ data: result, code: 0 })
                debugger
            })
            .catch(() => {
                multitest(
                    ossClient,
                    storeAs,
                    file,
                    checkpoint_temp,
                    resolve,
                    cdnUrl
                )
            })
    } else {
        ossClient
            .multipartUpload(storeAs, file, {
                parallel: 2,
                progress: (percent, cpt) => {
                    checkpoint_temp = cpt
                },
            })
            .then(function (res) {
                let result = resolveRes(res, file, cdnUrl)
                resolve({ data: result, code: 0 })
            })
            .catch(() => {
                debugger
                multitest(
                    ossClient,
                    storeAs,
                    file,
                    checkpoint_temp,
                    resolve,
                    cdnUrl
                )
            })
    }
}
/* eslint-enable */
